/**
 * Значки соцсетей.
 *
 * Отдельно от `icons.tsx` и по другим правилам: наш набор — обводка 1.5px, а
 * логотип чужой платформы узнаётся только в своей форме. Телеграм, нарисованный
 * нашей обводкой, перестаёт быть телеграмом, и человек просто не находит
 * глазами то, что ищет. Поэтому здесь заливка и оригинальные силуэты —
 * единственное место в интерфейсе, где мы не навязываем свою графику.
 *
 * Цвет при этом наш: значки монохромные и наследуют `currentColor`. Чужие
 * фирменные цвета в подвале превратили бы его в радугу.
 */
import type { ReactNode } from 'react';

export type SocialName = 'instagram' | 'telegram' | 'x' | 'tiktok' | 'linkedin' | 'mail';

const PATHS: Record<SocialName, ReactNode> = {
  // У инстаграма логотип и так контурный — рисуем обводкой, как в оригинале.
  instagram: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </g>
  ),
  telegram: (
    <path
      fill="currentColor"
      d="M21.6 4.2 2.9 11.4c-1 .4-1 1.8.1 2.1l4.7 1.5 1.8 5.5c.2.8 1.2 1 1.8.4l2.6-2.4 4.7 3.4c.7.5 1.7.1 1.9-.7l3.2-15.3c.2-1-.8-1.8-1.7-1.4ZM9.6 14.6l8.3-5.2-6.9 6.1-.3 3.3-1.1-4.2Z"
    />
  ),
  x: (
    <path
      fill="currentColor"
      d="M18.9 2H22l-7.1 8.1L23.3 22h-6.6l-5.2-6.8L5.6 22H2.5l7.6-8.7L1.8 2h6.7l4.7 6.2L18.9 2Zm-1.1 18.2h1.7L7.3 3.7H5.5l12.3 16.5Z"
    />
  ),
  tiktok: (
    <path
      fill="currentColor"
      d="M16.4 3c.3 2.1 1.5 3.4 3.6 3.6v2.6c-1.2.1-2.4-.2-3.5-.9v5.9c0 4.5-4.2 7.3-8.1 5.5-2.5-1.2-3.4-4.6-2-7.1 1.2-2.1 3.6-3 5.9-2.4v2.8c-.4-.1-.8-.2-1.2-.2-1.3 0-2.3 1.1-2.2 2.4.1 1.1 1.1 1.9 2.2 1.9 1.2 0 2.2-1 2.2-2.2V3h3.1Z"
    />
  ),
  linkedin: (
    <path
      fill="currentColor"
      d="M5 3.5a2.4 2.4 0 1 1 0 4.9 2.4 2.4 0 0 1 0-4.9ZM3.1 9.6h3.9V21H3.1V9.6Zm6.6 0h3.7v1.6h.1c.5-1 1.8-2 3.6-2 3.9 0 4.6 2.4 4.6 5.6V21h-3.9v-5.5c0-1.3 0-3-1.9-3s-2.2 1.4-2.2 2.9V21H9.7V9.6Z"
    />
  ),
  // Почта — наша, обводкой: своего логотипа у неё нет.
  mail: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.6" y="5" width="18.8" height="14" rx="2.4" />
      <path d="m3.5 7 8.5 6 8.5-6" />
    </g>
  ),
};

export function SocialIcon({ name, size = 18 }: { name: SocialName; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {PATHS[name]}
    </svg>
  );
}
